import styled from "styled-components";

export const StyledWrapper = styled.div<{ dynamicHeight: number | "auto"; transitionTime?: number }>`
    transition: height ${({ transitionTime }) => (typeof transitionTime === "number" ? `${transitionTime}s` : "0.2s")}
        cubic-bezier(0.18, 0.28, 1, 1.03);
    height: ${({ dynamicHeight }) => (typeof dynamicHeight === "number" ? `${dynamicHeight}px` : "auto")};
    overflow: ${({ dynamicHeight }) => (dynamicHeight === 0 ? "hidden" : "inherit")};
`;
